// third-party
import { Chance } from "chance";
import { filter } from "lodash";
// project imports
import services from "utils/mockAdapter";

const chance = new Chance();

// ==============================|| MOCK SERVICES ||============================== //

services.onPost("/api/cart/add").reply((config) => {
  try {
    const { product, products } = JSON.parse(config.data);

    // Find existing product in cart by id (the primary product identifier)
    const existingIndex = products.findIndex(
      (item) => String(item.id) === String(product.id)
    );

    let latestProducts;
    if (existingIndex !== -1) {
      // Product already in cart — increment quantity, keep existing itemId
      latestProducts = products.map((item, idx) => {
        if (idx === existingIndex) {
          const newQty = (item.quantity || 1) + (product.quantity || 1);
          return { ...item, quantity: newQty };
        }
        return item;
      });
    } else {
      // New product — assign a unique itemId
      const newProduct = { ...product, itemId: chance.timestamp() };
      latestProducts = [...products, newProduct];
    }

    const subtotal = latestProducts.reduce(
      (sum, p) => sum + (p.offerPrice || 0) * (p.quantity || 1),
      0
    );

    return [200, { products: latestProducts, subtotal }];
  } catch (err) {
    return [500, { message: "Internal server error" }];
  }
});

services.onPost("/api/cart/remove").reply((config) => {
  try {
    const { id, products } = JSON.parse(config.data);

    // Filter out the product to remove — compare with loose type matching
    const newProducts = products.filter(
      (item) => String(item.itemId) !== String(id)
    );

    // Recalculate subtotal from remaining products
    const subtotal = newProducts.reduce(
      (sum, p) => sum + (p.offerPrice || 0) * (p.quantity || 1),
      0
    );

    return [200, { products: newProducts, subtotal }];
  } catch (err) {
    return [500, { message: "Internal server error" }];
  }
});

services.onPost("/api/cart/update").reply((config) => {
  try {
    const { id, quantity, products } = JSON.parse(config.data);

    let oldSubTotal = 0;
    const latestProducts = products.map((item) => {
      if (String(item.itemId) === String(id)) {
        oldSubTotal = (item.quantity || 1) * (item.offerPrice || 0);
        return { ...item, quantity };
      }
      return item;
    });

    const subtotal = latestProducts.reduce(
      (sum, p) => sum + (p.offerPrice || 0) * (p.quantity || 1),
      0
    );

    return [200, { products: latestProducts, oldSubTotal, subtotal }];
  } catch (err) {
    return [500, { message: "Internal server error" }];
  }
});

services.onPost("/api/cart/billing-address").reply((config) => {
  try {
    const { address } = JSON.parse(config.data);
    return [200, { billing: address }];
  } catch (err) {
    return [500, { message: "Internal server error" }];
  }
});

services.onPost("/api/cart/discount").reply((config) => {
  try {
    const { total, code } = JSON.parse(config.data);
    let amount = 0;
    if (total > 0) {
      switch (code) {
        case "BERRY50":
          amount = chance.integer({ min: 1, max: total < 49 ? total : 49 });
          break;
        case "FLAT05":
          amount = total < 5 ? total : 5;
          break;
        case "SUB150":
          amount = total < 150 ? total : 150;
          break;
        case "UPTO200":
          amount = chance.integer({ min: 1, max: total < 199 ? total : 199 });
          break;
        default:
          amount = 0;
      }
    }

    return [200, { amount }];
  } catch (err) {
    return [500, { message: "Internal server error" }];
  }
});

services.onPost("/api/cart/shipping-charge").reply((config) => {
  try {
    const { shipping, charge } = JSON.parse(config.data);
    let newShipping = 0;
    if (shipping > 0 && charge === "free") {
      newShipping = -5;
    }
    if (charge === "fast") {
      newShipping = 5;
    }

    return [
      200,
      { shipping: charge === "fast" ? 5 : 0, newShipping, type: charge },
    ];
  } catch (err) {
    return [500, { message: "Internal server error" }];
  }
});

services.onPost("/api/cart/payment-method").reply((config) => {
  try {
    const { method } = JSON.parse(config.data);
    return [200, { method }];
  } catch (err) {
    return [500, { message: "Internal server error" }];
  }
});

services.onPost("/api/cart/payment-card").reply((config) => {
  try {
    const { card } = JSON.parse(config.data);
    return [200, { card }];
  } catch (err) {
    return [500, { message: "Internal server error" }];
  }
});

services.onPost("/api/cart/reset").reply(200, {});
